<template>
  <div v-cloak id="emailDetail" class="main-content flex-grow-1">
    <nav id="headerNav" class="navbar modal-navbar navbar-light bg-white my-lg-0 px-0">
      <div class="container-fluid d-flex justify-content-between flex-align-top">
        <div class="btn-toolbar">
          <a href="/">
            <img src="/images/favicon.png" width="36" alt="Sageflo Archiver" />
          </a>
          <h4 class="modal-title ml-2">Message Details</h4>
        </div>
        <button type="button" @click="closeDetail()" class="close align-top pr-2" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

      </div>
    </nav>
    <div id="detailContent" class="container-fluid">
      <div id="detail_print">
          <div class="d-none d-print-block" style="margin-left: 10px; margin-bottom: 0px; padding-bottom:0px; margin-top: -20px"><img src="images/print_logo.png" width="14%" height="14%" style="display: inline-block; vertical-align: baseline; line-height: .55in; margin-top:0px;margin-bottom:0px;"/><h3 style="display:inline-block; color: #382b2b;line-height: .69in; margin-top:0px;margin-bottom:0px;">&nbsp;Printed Copy</h3>
            <hr style="margin-top: -15px; margin-bottom: 0px;">
          </div>
          <iframe v-show="selectedRecord.channel!='s'" id="detailPrintFrame"></iframe>        
      </div>
      <div id="detail_container" class="row justify-content-around">
        <div id="campaign_details" class="col-3 bg-light pt-3" :class="{'d-print-none': (!this.privs.PE && !this.privs.AO)}">
          <div v-if="selectedRecord">
            <div v-if="!isPersona && sourceDisplayName" class="small mb-1 text-muted"><span class="font-weight-semibold">Source:</span> {{sourceDisplayName}}</div>
            <div v-if="campaign.name">
              <span class="font-weight-semibold">Name:</span>
              {{campaign.name}} 
            </div>
            <div v-if="campaign.description">
              <span class="font-weight-semibold">Description:</span>
              {{campaign.description}} 
            </div>
            <div v-if="campaign.id">
              <span class="font-weight-semibold">Campaign ID:</span> 
            {{campaign.id}}
            </div>
            <template v-if="selectedRecord.channel=='s'">
              <div >
                <span class="font-weight-semibold">Channel:</span>
                <span class="badge bg-secondary text-white">SMS</span>
              </div>
              <div>
                <span class="font-weight-semibold">Mobile Number:</span>
                {{selectedRecord.mobile_number}}
              </div>
              <div>
                <span class="font-weight-semibold">Sent on:</span>
                {{formatDate(selectedRecord.sent_dt, false, true)}}
              </div>
              <div>
                <span class="font-weight-semibold">Short Code:</span>
                {{selectedRecord.sender_mobile_code}}
              </div>
              <template v-if="campaign.purpose || campaign.marketing_program || campaign.marketing_strategy">
                <div>
                  <span class="font-weight-semibold">Type:</span>
                  {{campaign.purpose}}
                </div>
                <div>
                  <span class="font-weight-semibold">Marketing Program:</span>
                  {{campaign.marketing_program}}
                </div>
                <div>
                  <span class="font-weight-semibold">Marketing Strategy:</span>
                  {{campaign.marketing_strategy}}
                </div>
              </template>
              <!-- custom filter and metadata fields -->
              <template> <!-- TODO add custom filter support for SMS -->
                <div v-for="filter in advancedFilters" v-if="filter.name!='campaign_name' && filter.category=='sms'">
                  <span class="font-weight-semibold">{{filter.displayName}}:&nbsp;</span>
                  <template v-if="filter.type=='custom'">
                    <span v-if="(!filter.v2) && (selectedRecord[filter.column_name] != null)">{{selectedRecord[filter.column_name]}}</span>
                    <span v-else-if="filter.v2 && (selectedRecord.fields[filter.name])">{{selectedRecord.fields[filter.name]}}</span>
                    <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                  </template>
                  <template v-else-if="selectedRecord.metadata">
                    <span v-if="selectedRecord.metadata[filter.metadata_attr]">{{selectedRecord.metadata[filter.metadata_attr]}}</span>
                    <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                  </template>
                </div>
              </template>
              <!-- /custom filter and metadata fields -->
            </template>
            <template v-else-if="selectedRecord.channel=='d'">
              <div >
                <span class="font-weight-semibold">Channel:</span>
                <span class="badge bg-secondary text-white">PDF</span>
              </div>
              <div>
                <span class="font-weight-semibold">Sent on:</span>
                {{formatDate(selectedRecord.sent_dt, false, true)}}
              </div>
              <div v-if="campaign.purpose">
                <span class="font-weight-semibold">Type:</span>
                {{campaign.purpose}}
              </div>
              <div v-else-if="campaign.metadata && campaign.metadata.channel">
                <span class="font-weight-semibold">Type:</span>
                {{campaign.metadata.channel}}
              </div>
              <div v-if="campaign.marketing_program">
                <span class="font-weight-semibold">Marketing Program:</span>
                {{campaign.marketing_program}}
              </div>
              <div v-if="campaign.marketing_strategy">
                <span class="font-weight-semibold">Marketing Strategy:</span>
                {{campaign.marketing_strategy}}
              </div>
              <!-- custom filter and metadata fields -->
              <div v-for="filter in advancedFilters" v-if="filter.name!='campaign_name' && filter.category=='mail'">
                <span class="font-weight-semibold">{{filter.displayName}}:&nbsp;</span>
                <template v-if="filter.type=='custom'">
                  <span v-if="(!filter.v2) && (selectedRecord[filter.column_name] != null)">{{selectedRecord[filter.column_name]}}</span>
                  <span v-else-if="filter.v2 && (selectedRecord[filter.name] != null)">{{selectedRecord[filter.name]}}</span>
                  <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                </template>
                <template v-else-if="selectedRecord.metadata">
                  <span v-if="selectedRecord.metadata[filter.metadata_attr]">{{selectedRecord.metadata[filter.metadata_attr]}}</span>
                  <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                </template>
              </div>
              <!-- /custom filter and metadata fields -->
            </template>
            <template v-else>
              <div v-if="!isPersona">
                <span class="font-weight-semibold">Recipient:</span>
                {{selectedRecord.email}}
              </div>
              <div>
                <span class="font-weight-semibold">Sent on:</span>
                {{formatDate(selectedRecord.sent_dt, false, true)}}
              </div>
              <div>
                <span class="font-weight-semibold">Sent from:</span>
                <span class="small">{{selectedRecord.from_email}}</span>
              </div>
              <div>
                <span class="font-weight-semibold">Sender name:</span>
                {{selectedRecord.from_name}}
              </div>
              <div>                  
                <span class="font-weight-semibold">Subject:</span>
                {{selectedRecord.subject}}
              </div>
              <div v-if="campaign.purpose">
                <span class="font-weight-semibold">Type:</span>
                {{campaign.purpose}}
              </div>
              <div v-else-if="campaign.metadata && campaign.metadata.channel">
                <span class="font-weight-semibold">Type:</span>
                {{campaign.metadata.channel}}
              </div>
              <div v-if="keywords.length">
                <span class="font-weight-semibold">Keywords:</span>
                <span v-for="kw in keywords" class="badge badge-secondary ml-1">{{kw}}</span>
              </div>
              <div v-if="campaign.marketing_program">
                <span class="font-weight-semibold">Marketing Program:</span>
                {{campaign.marketing_program}}
              </div>
              <div v-if="campaign.marketing_strategy">
                <span class="font-weight-semibold">Marketing Strategy:</span>
                {{campaign.marketing_strategy}}
              </div>
              <!-- custom filter and metadata fields -->
              <div v-for="filter in advancedFilters" v-if="filter.name!='campaign_name' && filter.category=='mail'">
                <span class="font-weight-semibold">{{filter.displayName}}:&nbsp;</span>
                <template v-if="filter.type=='custom'">
                  <span v-if="(!filter.v2) && (selectedRecord[filter.column_name] != null)">{{selectedRecord[filter.column_name]}}</span>
                  <span v-else-if="filter.v2 && (selectedRecord[filter.name] != null)">{{selectedRecord[filter.name]}}</span>
                  <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                </template>
                <template v-else-if="selectedRecord.metadata">
                  <span v-if="selectedRecord.metadata[filter.name]">{{selectedRecord.metadata[filter.name]}}</span>
                  <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                </template>
              </div>
              <div v-for="meta,metaKey in adhocMeta">
                <span class="font-weight-semibold">{{metaKey}}:&nbsp;</span>
                {{meta}}
              </div>

              <!-- /custom filter and metadata fields -->
            </template>
            <hr>
            <div v-if="selectedRecord.channel == 's' && showSmsEvents && selectedRecord.events && selectedRecord.has_event_data && Object.keys(selectedRecord.events).length > 0">
              <h5>Activity</h5>
              <span class="event-summary" v-html="formatSmsEventSummary(selectedRecord.events)"></span>
            </div>
            <div v-else-if="selectedRecord.channel != 's' && showEmailEvents && selectedRecord.events && selectedRecord.has_event_data">
              <h5>Activity</h5>
              <span class="event-summary" v-html="formatEventSummary(selectedRecord.events)"></span>
            </div>
          </div>
        </div>
        <!-- email content -->
        <div id="content_holder" class="col-9 d-print-none">
          <nav id="detailNavbar" class="navbar navbar-light bg-white my-lg-0 px-0" 
            role="navigation">
            <div class="container-fluid d-flex w-100 justify-content-between px-0">
              <div id="detailToolbar" class="btn-toolbar">
                <div class="btn-group mr-3">
                  <button id="btnPrevious" 
                    type="button" class="btn btn-sm btn-indigo" 
                    @click="selectPreviousCampaign($event)"
                    :disabled="disablePrevious"
                    data-toggle="tooltip" title="Show previous message" data-placement="bottom">
                    <span class="glyphicons glyphicons-chevron-left"></span>
                  </button>
                  <button id="btnNext"
                    type="button" class="btn btn-sm btn-indigo" 
                    @click="selectNextCampaign($event)"
                    :disabled="disableNext"
                    data-toggle="tooltip" title="Show next message" data-placement="bottom">
                    <span class="glyphicons glyphicons-chevron-right"></span>
                  </button>
                </div>

                <div class="btn-group mr-3">
                  <button v-if="privs.PE" class="btn btn-sm btn-default w-100" data-toggle="tooltip" title="Print copy of message" data-placement="bottom" @click="printMessage">
                    <span class="glyphicons glyphicons-print"></span>
                  </button>
                  <button v-if="!isPersona && privs.DR" class="btn btn-sm btn-default w-100" data-toggle="tooltip" title="Delete message" 
                    data-placement="bottom"
                    @click="deleteMessage">
                    <span class="glyphicons glyphicons-bin"></span>
                  </button>
                  <button v-if="privs.DF && selectedRecord.channel!='s'" class="btn btn-sm btn-default w-100" data-toggle="tooltip" title="Download copy" data-placement="bottom"
                    @click.prevent="downloadFile('/api/v1/email/'+ encodeURIComponent(selectedRecord.locator),(selectedRecord.doc_type=='pdf')?'PDF file':'HTML email file');trackSubAccountActivity(selectedRecord.sub_account_id,'email_download');trackEmailDownload(selectedRecord);">
                    <span class="glyphicons glyphicons-disk-import"></span>
                  </button>
                </div>

                <div v-if="selectedRecord.channel=='e'" class="btn-group mr-3">
                  <button class="btn btn-sm btn-outline-gray w-100" 
                    :class="{active: detailView=='zoomout'}" 
                    @click.prevent="setDetailView('zoomout');scaleDetailPane()" 
                    data-toggle="tooltip" title="Fit image to browser" data-placement="bottom">
                    <span class="glyphicons glyphicons-fit-image-to-frame"></span>
                  </button>
                  <button class="btn btn-sm btn-outline-gray w-100" 
                    :class="{active: detailView=='desktop'}" 
                    @click.prevent="setDetailView('desktop'); scaleDetailPane(true);" 
                    data-toggle="tooltip" title="Desktop view" data-placement="bottom">
                    <span class="glyphicons glyphicons-imac"></span>
                  </button>
                  <button class="btn btn-sm btn-outline-gray w-100" 
                    :class="{active: detailView=='mobile'}" 
                    @click.prevent="setDetailView('mobile'); scaleDetailPane(true);" 
                    data-toggle="tooltip" title="Mobile view" data-placement="bottom">
                    <span class="glyphicons glyphicons-iphone"></span>
                  </button>
                  <button class="btn btn-sm btn-outline-gray w-100" 
                    :class="{active: detailView=='tablet'}" 
                    @click.prevent="setDetailView('tablet'); scaleDetailPane(true);" 
                    data-toggle="tooltip" title="Tablet view" data-placement="bottom">
                    <span class="glyphicons glyphicons-ipad"></span>
                  </button>
                </div>

                <template v-if="!isPersona && privs.RE && selectedRecord.channel=='e' && subAccountCanResend()">
                  <div class="d-inline-block">
                    <button class="btn btn-indigo btn-sm" @click="confirmResend(selectedRecord)">
                      <span class="glyphicons glyphicons-send"></span> Resend
                    </button>              
                  </div>
                </template>
                
              </div>
            </div>
          </nav>

          <div v-show="loadingEmail" id="loadMasker" :class="['loading-pane-' + detailViewForDisplay]">
            <div style="line-height: calc(100vh - 100px);text-align: center;">
              <div class="spinner text-gray">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
          <iframe v-show="selectedRecord.channel!='s'" id="detailPane" class="detail-pane d-print-none" 
            :class="['detail-pane-' + detailViewForDisplay]"
            :style="{'pointer-events': fullyLoaded || privs.PC ? 'auto' : 'none'}" 
            @load="setLoadedFrame()"
            ></iframe>
          <div v-if="selectedRecord.channel=='s'" class="detail-pane detail-pane-mobile">
            <div class="sms-detail">
              {{selectedRecord.message}}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import {mapState} from 'vuex'
import DateFormatting from '@/mixins/date-formatting'
import CustomFields from '@/mixins/custom-fields'
import Email from '@/mixins/email'
import Event from '@/mixins/event'
import Tracking from '@/mixins/tracking'
import ResendEmail from './resend-email'
const findIndex = require("lodash").findIndex

export default {
  mixins: [DateFormatting,Email,Event,Tracking,CustomFields],
  components: {ResendEmail},
  data: function() {return {
    fullyLoaded: false,
    loadingEmail: true
  }},
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedRecord: (state)=>state.search.selectedEmail,
      activeSearch: (state)=>state.search.activeSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      resend: (state)=>state.search.resend,
      showEmailEvents: (state)=>state.user.showEmailEvents,
      showSmsEvents: (state)=>state.user.showSmsEvents,
    }),
    detailViewForDisplay: function() {
      if (this.selectedRecord.channel=='d') {
        return 'desktop';
      } else {
        return this.detailView;
      }
    },
    currentIndex: function() {
      return findIndex(this.emails,{'uuid': this.selectedRecord.uuid});
    },
    disablePrevious: function() {
      if (this.currentIndex==-1 || this.currentIndex <= 0) {
        return true;
      } else {
        return false;
      }
    },
    disableNext: function() {
      if (this.currentIndex==-1 || this.currentIndex >= this.emails.length -1) {
        return true;
      } else {
        return false;
      }
    },
    keywords: function() {
      if (this.selectedRecord.metadata && this.selectedRecord.metadata.keywords) {
        try {
          return this.selectedRecord.metadata.keywords.split(" ");
        } catch(e) {
          console.warn(e);
        }
      }
      return []; // catch all
    },
    isPersona: function() {
      return this.activeView=='persona-detail'
    },
    adhocMeta: function() {
      let ret = {};
      if (this.selectedRecord.metadata) {
        for (const key in this.selectedRecord.metadata) {
          if (!this.uiConfig.metadata_fields.find(s=>s.name == key) && ['campaign_name','keywords','channel','program','strategy','campaign_id'].indexOf(key)==-1) {
            ret[this.prettifyCaption(key)] = this.selectedRecord.metadata[key];
          }
        }
      }
      return ret;
    },
    sourceDisplayName: function() {
      if (this.selectedRecord.sub_account_id && this.uiConfig.sub_accounts && this.uiConfig.sub_accounts.length >1) {
        let subAccount = this.uiConfig.sub_accounts.find(s=>s.id == this.selectedRecord.sub_account_id)
        if (subAccount) return subAccount.sub_account_display_name
      } 
      return null;
    }
  },
  mounted: function() {
    let that = this;
    $('#emailDetail').tooltip({selector: '[data-toggle="tooltip"]', html:true, trigger: 'hover', delay: { "show": 500, "hide": 100 }});

    $('#detailToolbar').on('show.bs.dropdown', function () {
      that.showResendDifferent = false;
    })

  },
  methods: {
    closeDetail(){
      let name = this.activeView=='persona-detail' ? 'personas' : 'search'

      this.$store.commit("setActiveView",name);
    },
    setLoadedFrame() {
      this.scaleDetailPane(this.detailViewForDisplay!='zoomout');
      this.loadingEmail = false;
    },
    scaleDetailPane(reset) {
      this.fullyLoaded = true;
      var iframe = document.getElementById('detailPane');

      if (reset) {
        iframe.style.height = '';

        let scalePct = 100;
        iframe.style.msTransform='scale(1)';
        iframe.style.msTransformOrigin='0% 0%';
        iframe.style.transform='scale(1)';
        iframe.style.transformOrigin='0% 0%';

      } else {
        try {
          var eHeight = iframe.contentWindow.document.body.scrollHeight;
          var iHeight = $(window).height() - 110;
          var scalePct = iHeight/eHeight;

          iframe.style.height = (($(window).height() - 110)/scalePct) + 'px';

          iframe.style.msTransform='scale('+scalePct+')';
          iframe.style.msTransformOrigin='0% 0%';
          iframe.style.transform='scale('+scalePct+')';
          iframe.style.transformOrigin='0% 0%';

        } catch(e) {
          console.warn(e);
        }
      }

      this.setPermissions(iframe);
    },
    setPermissions(iframe) {
      try {
        if (!this.privs.PC) {
          $(iframe.contentWindow.document.body).on('click', function(e) {
              return false;
          });        
          iframe.contentWindow.document.body.addEventListener("contextmenu", function(e){
            e.preventDefault();
          }, false);
        } else {
          $(iframe.contentWindow.document.body).contents().find('a').attr('target','_new');
        } 
        this.fullyLoaded = true;
      } catch(e) {
        console.warn(e);
      }

    },
    setDetailView(name){
      this.$store.commit("setDetailView",name);
    },
    setSelectedEmail(email){
      this.$store.commit("setSelectedEmail",email);
    },
    selectNextCampaign() {
      let index = this.currentIndex;
      if (index!=-1 && index < this.emails.length -1) {
        $('#btnNext').tooltip('hide');
        this.setSelectedEmail(this.emails[index+1]);
      }
    },
    selectPreviousCampaign() {
      let index = this.currentIndex;
      if (index!=-1 && index > 0) {
        $('#btnPrevious').tooltip('hide');  
        this.setSelectedEmail(this.emails[index-1]);
      }
    },
    doShowResendDifferent(){
      this.differentEmailAddress = "";      
      this.showResendDifferent = true;
      this.$nextTick(()=>{
        $(`#detailResend`).focus();        
      })
    },
    confirmResend(email) {
      this.$parent.$refs.resendEmail.show(email)
    },
    closeDropdown() {
      $('#detailToolbar').dropdown('toggle');
    },
    async loadContent() {
      let detailPane = document.getElementById('detailPane');
      if (this.selectedRecord.locator) {
        this.loadingEmail = true;
        this.fullyLoaded = false;
        let url;
        if (this.selectedRecord.metadata?.pdf2){
          //This is written this way becayse extractPdf2 periodically
          //checks if the same record is selected.  If the record changes, then it bails
          //and returns a null url
          try {
            url = await this.$store.dispatch("extractPdf2",{});
            if (!url){
              return;
            }
          } catch (err){
            console.log(err)
            this.loadingEmail = false;
            return
          }
        } else {
          url = this.getEmailUrl(this.selectedRecord);
        }
        if (detailPane.src == url) {
          this.scaleDetailPane(detailView!='zoomout');
        } else {
          detailPane.src = url;
        }
        this.loadPrintFrame('detailPrintFrame',detailPane.src,'detail_print');
        this.$nextTick(()=>{
          window.scrollTo(0,0);
        });
        setTimeout(()=>{
          this.setPermissions(detailPane);
        },500);

        /*
        //this hides the wait graphic after 1.2 seconds, even if the email hasn't loaded yet
        setTimeout(()=>{
          this.loadingEmail = false;
        },1200);
        */
        if (this.selectedRecord.doc_type != "pdf"){
          //this will turn off the waiting graphic when the html is loaded.
          //this isn't necessary for pdf, where this will happen on the load event on the iframe
          this.iframeReady2("detailPane",()=>{this.loadingEmail = false;})
        }
      }
    },
    printMessage() {
      if (this.selectedRecord.channel=='d') {
        let iframe = document.getElementById('detailPane');
        iframe.contentWindow.print();
      } else {
        let printFrame = document.getElementById('detailPrintFrame')
        var whenReady = function(callback) {
          try {
            let state = printFrame.contentWindow.document.readyState;
            if (state === 'complete' || state === 'interactive') {
              callback('readyState: ' + state); // check not already loaded prior to this function being called
            } else if (document.addEventListener) {
              document.addEventListener('DOMContentLoaded', callback); // for standards compliant browsers (including IE 9+)
            }
          } catch(e) {
            console.warn(e);
          }
        };

        whenReady(()=>{
          var iframeDocument = printFrame.contentDocument || printFrame.contentWindow.document;
          printFrame.style.height = iframeDocument.body.scrollHeight + 'px'

          window.print();
          let activityType = (this.selectedRecord.channel == 's') ? 'sms_print' : 'email_print';
          this.trackSubAccountActivity(this.selectedRecord.sub_account_id,activityType);
          let props = {
            sub_account_id: this.selectedRecord.sub_account_id,
          }
          this.$store.dispatch("track",{name:activityType,props:props})
        });
      }

    },
    deleteMessage() {
      this.$parent.$refs.searchBar.confirmDelete('selected');
    },
    subAccountCanResend(){
      let canResend = false;
      if (this.uiConfig.sub_accounts){
        let subAccount = this.uiConfig.sub_accounts.find(s=>s.id == this.selectedRecord.sub_account_id)
        if (subAccount) {
          canResend = subAccount.can_resend;
          if (canResend){
            let platformConfig = subAccount.platform_configs[subAccount.resend_platform_id];
            if (platformConfig){
              let resendRequiredField = platformConfig.config.resend_required_field;
              if (resendRequiredField){
                if (! this.selectedRecord[resendRequiredField]){
                  canResend = false;
                }
              }
            }
          }
        }
      
      }
      return canResend;
    },
    trackEmailDownload(email){
      let props = {
        sub_account_id: email.sub_account_id,
      }
      this.$store.dispatch("track",{name:"email_download",props:props})
    },

  },
  watch: {
    'activeView': function(name){
      if (name == 'detail' || name == 'persona-detail'){
        this.loadContent();
      }
    },
    'selectedRecord': function(newVal) {
      if (this.activeView == 'detail' || this.activeView == 'persona-detail'){
        console.log(newVal);
        this.loadContent();
      }
    }
  }, 
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.sms-detail {
  margin: .5rem;
  border-radius: 7px;
  background-color: var(--indigo);
  color: #ffffff;
  padding: .25rem .35rem .4rem .35rem;

}
@media print {
  #detail_container {
    margin-top: -50px;
    position: relative;
  }
  #detail_print {
    page-break-after: always;
    break-after: page;
    -webkit-column-break-after: always;
    position: relative;
    display: inline-block;
    width: 100%!important;
    max-width: 100%;
  }
  #campaign_details, #campaign_details.col-3, #campaign_details.bg-light{
    margin-top: 80px;
    position: relative;
    display: block;
    flex: none;
    width: 100%!important;
    max-width: 100%;
    background-color: #ccc!important;
  }
  #campaign_details.d-print-none {
    display: none!important;
    visibility: hidden!important;
  }
  h5 > small.float-right {
    float: none!important;
    margin-top: .25rem;
    display: block;
  }

  span.badge.bg-secondary {
    background-color: none!important;
    color: #222222;
  }
}
</style>
<style>
@media screen {
  #detailPrintFrame {
    z-index: -500;
    position: absolute;
    opacity: 0;
    width: 100vw;
    top: -50000px;
  }
}

@media print {
  #detailPrintFrame.hidden {
    display: none!important;
    visibility: hidden!important;
    left: -1200px;
  }
  #detailPrintFrame {
    display: inline-block;
    position: relative;
    padding-top: 0px;
    overflow: visible;
    visibility: visible!important;
    overflow: scroll;
    opacity: 1;
    width: 100vw;
    border: none;
  }
}

#emailDetail {
  position: absolute; 
  top: 0px; 
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 1050;
  background-color: var(--white);
}

#content_holder {
  height: calc(100vh - 50px);
}

#headerNav {
  border-bottom:  1px solid rgba(0,0,0,.15);
  height: 60px;
}
.navbar.modal-navbar {
  padding: 0px;
}

#loadMasker {
  position: absolute;
  height: calc(100vh - 50px);
  width: 100%;
  z-index: 1000;
  background-color: var(--white);
}


#loadMasker.loading-pane-mobile {
  height: 570px;
  width: 340px;
  left: 25px;
  margin-top: 65px;
}

#loadMasker.loading-pane-tablet {
  height: 924px;
  width: 728px !important;
  left: 35px;
  margin-top: 65px;
}
</style>